import { useEffect, useState, useRef } from "react";
import cn from "clsx";
import styles from "../reviews.module.scss";
type Props = {
  activeIndex: number;
  navList: string[];
  targetClassName?: string;
  onChange?: (index: number) => void;
};

export default function TabNav({ navList, onChange, activeIndex }: Props) {
  // const [indexActive, setIndexActive] = useState<number>(0);

  const onNavClick = (index: number) => {
    onChange?.(index);
  };

  useEffect(() => {}, []);

  return (
    <div className={styles.tab_nav}>
      <div className={styles.cate_nav_list}>
        {navList.map((nav: string, index: number) => {
          return (
            <div
              key={index}
              className={cn(styles.cate_nav_item, index === activeIndex ? styles.active : "")}
              onClick={() => onNavClick(index)}
            >
              {nav}
            </div>
          );
        })}
      </div>
    </div>
  );
}
